import { ancestorNodeOfType } from "./ancestors.js";
import { getEnvironmentName } from "./environments.js";

export const mathAncestorNode = (state, pos) =>
    ancestorNodeOfType(state, pos, "$MathContainer") ||
    ancestorNodeOfType(state, pos, "EquationEnvironment") ||
    ancestorNodeOfType(state, pos, "EquationArrayEnvironment");

export const parseMathContainer = (state, nodeRef, ancestorNode) => {
    const innerContent = state.doc.sliceString(nodeRef.from, nodeRef.to).trim();
    if (!innerContent.length) {
        return null;
    }

    let content = innerContent;
    let displayMode = false;
    let passToMathJax = true;
    let pos = nodeRef.from;

    if (ancestorNode.type.is("$Environment")) {
        const environmentName = getEnvironmentName(ancestorNode, state);
        if (environmentName) {
            if (environmentName === "tikzcd") {
                passToMathJax = false;
            }
            if (environmentName !== "math" && environmentName !== "displaymath") {
                content = state.doc.sliceString(ancestorNode.from, ancestorNode.to).trim();
                pos = ancestorNode.from;
            }
            if (environmentName !== "math") {
                displayMode = true;
            }
        }
    } else if (ancestorNode.type.is("BracketMath") || Boolean(ancestorNode.getChild("DisplayMath"))) {
        displayMode = true;
    }

    return { content, displayMode, passToMathJax, pos };
};
